import {Tooltip, TooltipProps, styled, tooltipClasses} from '@mui/material'
import {ReactElement, ReactNode} from 'react'

export interface IToolTipCustomProps {
  children: ReactElement
  /** Plain string or rich JSX content (e.g. a bulleted list). */
  title: ReactNode
  /**
   * Controlled visibility (e.g. force-open during a drag). Omit to let MUI
   * drive it on hover/focus — the uncontrolled default, used by transits.
   */
  open?: boolean
  placement?: any
}

const TooltipStyled = styled(
  ({className, placement = 'top', ...props}: TooltipProps) => (
    <Tooltip
      {...props}
      arrow
      placement={placement}
      classes={{popper: className}}
    />
  ),
)(({theme}) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: theme.palette.text.primary,
    whiteSpace: 'pre-wrap',
    fontSize: theme.typography.pxToRem(16),
    border: `1px solid ${theme.palette.divider}`,
  },
}))

export default function ToolTipCustom({
  children,
  title,
  open,
  placement = 'top',
}: IToolTipCustomProps) {
  // open === undefined → MUI runs uncontrolled (hover/focus).
  return (
    <TooltipStyled title={title} open={open} placement={placement}>
      {children}
    </TooltipStyled>
  )
}

export {TooltipStyled}
